import { SocketioService } from './socketio.service';
import { SharedService } from '../shared/shared.service';
import { DashboardService } from './dashboard.service';
import { Url } from 'url';
import { ViewChild, ElementRef, AfterViewInit,Component, ViewContainerRef, ViewEncapsulation, OnDestroy, HostListener, Inject, OnInit } from '@angular/core';
import {NavItem} from './nav-item';
import {NavService} from './nav.service';
import { MatSidenav } from '@angular/material';
import { NgxSpinnerService } from 'ngx-spinner';
import { Router } from '@angular/router';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import { Logger } from 'angular2-logger/core';

import { environment } from '../../environments/environment';
@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent implements OnInit, OnDestroy, AfterViewInit{
  @ViewChild('appDrawer') appDrawer: ElementRef;
  @ViewChild('sidenav') sidenav: MatSidenav;

  isExpanded = true;
  showSubmenu: boolean = false;
  isShowing = false;
  showSubSubMenu: boolean = false;
  public state_menu: boolean;
  public fade_box: boolean;
  public status: boolean;
  public url_menu: any[] = [
    {
      'label': 'Cambiar Contraseña',
      'url': './#/dashboard/changepassword'
    },
    {
      'label': 'Ayuda',
      'url': '../../../assets/help/Bienvenida.html'
    }
  ];

  constructor(
    private _socketioService: SocketioService,
    public _sharedService: SharedService,
     private _dashboardService: DashboardService,
     private navService: NavService,
     private spinner: NgxSpinnerService,
    private _router: Router,
    public toastr: ToastsManager,
    public logger: Logger
  ) {
    
  }

  ngOnInit() {
  }

  mouseenter() {
    if (!this.isExpanded) {
      this.isShowing = true;
    }
  }

  mouseleave() {
    if (!this.isExpanded) {
      this.isShowing = false;
    }
  }

  ngAfterViewInit() {
    this.navService.appDrawer = this.appDrawer;
  }

  Menu(state) {
    console.log('aqui entro', state);
    if(this.state_menu == state)
      state= !state;
      
    this.state_menu = state;
    this.fade_box = state;
    if(state)
      this.navService.openNav();
    else
      this.navService.closeNav();
  }

  closeMenu() {
    this.navService.closeNav();
  }

  onLogout() {
    this.spinner.show();
    this._sharedService.logout().subscribe(
      data => {
        if (data.code_status === 200) {
          this.toastr.success('Has salido del sitio', 'Éxito!');
          this._sharedService.user = null;
          this.logger.log(this._sharedService.user);
          this._router.navigate(['/auth', {}]);
          this._sharedService.setCookie('auth_token', '', -1, environment.c_domain);
        } else {
          this.toastr.error(data.message, 'Error');
          this.logger.log(data);
        }
        this.spinner.hide();
      },
      error => {
        this.toastr.error('Ocurrió un error, por favor intente de nuevo', 'Error');
        this.logger.log(<any>error);
        this.spinner.hide();
      }
    );
  }

  ngOnDestroy(): void {
    //Called once, before the instance is destroyed.
    //Add 'implements OnDestroy' to the class.
    
  }
  /*
  @HostListener('window:beforeunload')
  async ngOnDestroy() {
    console.log("Entramos acá!");
    return "Nos vemos perro";
  }*/


}



// WEBPACK FOOTER //
// /home/ec2-user/PasoAgentes/PA_frontend_routemobile/src/app/dashboard/dashboard.component.ts